import { render, staticRenderFns } from "./ByHall.vue?vue&type=template&id=35ebfffc&scoped=true&"
import script from "./ByHall.vue?vue&type=script&lang=js&"
export * from "./ByHall.vue?vue&type=script&lang=js&"
import style0 from "./ByHall.vue?vue&type=style&index=0&id=35ebfffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ebfffc",
  null
  
)

export default component.exports